<script>
  import { onMount } from 'svelte';
  import * as d3 from 'd3';
  import { gen_feature_option, move_options } from './FeatureSelectionView.js'
  import { color_dict } from './constant.js'
  
  // Export let name
  let FeatureSelectionView = undefined

  // Draw overlap view
  onMount(async() => {
    
    // Generate benign_softmax_weightlifting option
    gen_feature_option(
      'benign_avg_delta',
      // 'Skeleton shift in Benign Video',
      'Benign Frame',
      '#00BB00'
    )

    // Generate attacked_softmax_weightlifting option
    gen_feature_option(
      'attacked_avg_delta',
      // 'Skeleton shift in Attacked Video',
      'Attacked Frame',
      color_dict['attacked']
    )

    // Move feature option box
    move_options()

  })
  
</script>

<style>

  .feature-icon {
    display: inline-block;
  }

  .feature-text {
    font-size: 13px;
    width: 120px;
    position: absolute;
    transform: translate(20px, -22px);
  }

  

</style>

<div id='feature-selection-view' class='pose-view' bind:this={FeatureSelectionView}>

  <!-- benign_avg_delta -->
  <div id='feature-benign_avg_delta'>
    <div id='feature-benign_avg_delta-icon' class='feature-icon'></div>
    <div id='feature-benign_avg_delta-text' class='feature-text'></div>
  </div>
  
  <!-- attacked_avg_delta -->
  <div id='feature-attacked_avg_delta'>
    <div id='feature-attacked_avg_delta-icon' class='feature-icon'></div>
    <div id='feature-attacked_avg_delta-text' class='feature-text'></div>
  </div>
</div> 

